// src/components/RespondentsTable.jsx
import React from 'react';

const formatDate = (isoDate) => {
  if (!isoDate) return '-';
  const date = new Date(isoDate);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

const RespondentsTable = ({ respondents }) => {
  return (
    <div className="shadow-md p-6 rounded-lg mt-4">
      <h3 className="text-lg  mb-4 text-blue-700" style={{fontFamily: 'Poppins'}}>Respondents</h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead className="bg-blue-100 text-blue-700 ">
            <tr>
              <th className="p-3 text-left font-normal">Respondent Name</th>
              <th className="p-3 text-left font-normal">Email ID</th>
              <th className="p-3 text-left font-normal">Response Completed On</th>
              <th className="p-3 text-left font-normal">Status</th>
            </tr>
          </thead>
          <tbody>
            {respondents.map((r, i) => (
              <tr key={i} className="border-b hover:bg-blue-50">
                <td className="p-3">{r.first_name}</td>
                <td className="p-3">{r.user_name}</td>
                <td className="p-3">{formatDate(r.response_completed_on)}</td>
                <td className="p-3">{r.status}</td>
              </tr>
            ))}
            {respondents.length === 0 && (
              <tr>
                <td colSpan="4" className="p-4 text-center text-gray-500">
                  No respondents found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RespondentsTable;
